import libraryRoutes from './routes';
import librariesSlice from '../libraries/store/libraries.store';
export { libraryRoutes };

const moduleConfig = {
  routes: libraryRoutes,
  reducers: {
    libraries: librariesSlice.reducer,
  },
};

export default moduleConfig;
